import ACTION_TYPE from '../actions/actionTypes';
import localStorage from 'redux-persist/es/storage';

// initialize userToken from local storage
const userToken = localStorage.getItem('userToken') ? localStorage.getItem('userToken') : null;

const initialState = {
    loading: false,
    userInfo: null,
    userToken,
    error: null,
    success: false
};

const authReducer = (state = initialState, action) => {
    const { data } = action;
    switch (action.type) {
        case ACTION_TYPE.AUTH_SUCCESS:
            return {
                ...state,
                userToken: data.token,
                userInfo: data.user_data,
                loading: false,
                error: null,
                success: true
            };
        case ACTION_TYPE.AUTH_FAILED:
        case ACTION_TYPE.AUTH_USERINFO_FAILED:
            return {
                loading: false,
                error: data,
                success: false
            };
        case ACTION_TYPE.AUTH_USERINFO:
            return {
                ...state,
                userInfo: data,
                loading: false,
                error: null,
                success: true
            };
        case ACTION_TYPE.AUTH_LOGOUT:
            return {
                loading: false,
                userInfo: null,
                userToken: null,
                error: null
            };
        default:
            return state;
    }
};

export default authReducer;
